import { render, staticRenderFns } from "./createCompany.vue?vue&type=template&id=63e8604a&scoped=true&"
import script from "./createCompany.vue?vue&type=script&lang=js&"
export * from "./createCompany.vue?vue&type=script&lang=js&"
import style0 from "./createCompany.vue?vue&type=style&index=0&lang=css&"
import style1 from "../statistics/css/createCompany.css?vue&type=style&index=1&id=63e8604a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8604a",
  null
  
)

export default component.exports